import { NgModule } from '@angular/core';
import { LastChannelActivityPipe } from './last-channel-activity.pipe';

@NgModule({
  declarations: [LastChannelActivityPipe],
  exports: [LastChannelActivityPipe],
})
export class LastChannelActivityModule {}
